import { Component } from '@angular/core';
import { NavController, NavParams} from 'ionic-angular';

@Component({
    selector: 'page-category-section-single',
    templateUrl: 'category-section-single.html'
})
export class CategorySectionSinglePage {

    title: string;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.title = navParams.get('data');
    }

}



// WEBPACK FOOTER //
// ./src/pages/category-section-single/category-section-single.ts